<template>
  <div>
    <el-row>
      <el-col span="16" :offset=4>
        <span style="font-size: 16px; font-weight: bold;">{{name}} 设定参数</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="16" :offset=4>
        <el-select style="width: 265px" v-model="bigLightHight" size="small">
          <el-option key="0" label="高" value="High">
          </el-option>
          <el-option key="1" label="中" value="Middle">
          </el-option>
          <el-option key="2" label="低" value="Low">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="readonly === 0">
      <el-col span="16" :offset=4>
        <el-button type="primary" class="attr-window-button" round @click="save()">
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bigLightHight: 'Middle',
      returnStr: {
        data: {
          bigLightHight: ''
        },
        nameText: ''
      }
    }
  },
  computed: {
    getProperty: function() {
      return this.value
    }
  },
  watch: {
    getProperty: {
      handler: function(newValue) {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.value && this.value.bigLightHight) {
        this.bigLightHight = this.value.bigLightHight
      }
    },
    save() {
      this.returnStr.data.bigLightHight = this.bigLightHight
      this.returnStr.nameText = this.bigLightHight === 'High' ? this.name + ' 高' : this.bigLightHight === 'Middle' ? this.name + ' 中' : this.name + ' 低'
      console.log(JSON.stringify(this.returnStr))
      this.$emit('callBackJson', this.returnStr)
    }
  }
}
</script>

<style scoped>
.el-row {
  text-align: center;
}
.el-row:not(:first-child) {
  margin-top: 16px;
}
.el-row:last-child {
  margin-top: 20px;
}
/deep/ .el-radio{
  display: block;
  line-height: 30px;
  white-space: normal;
  margin-right: 0;
}
.attr-window-button {
  width: 96px;
  height: 40px;
  background-color: #4D78FF;
  border-color: rgb(77, 120, 255);
}
.attr-window-button:hover {
  background-color: #355cd8;
}
/deep/ .el-input__inner {
  /* background-color: #131B25;
  color:white ; */
}

</style>
